export const SET_TRANSACTION = "SET_TRANSACTION";
export const SET_PAYMENT_STATUS = "SET_PAYMENT_STATUS";
